import React, { useEffect, useState } from 'react';
import DashboardLayout from '../layout/DashboardLayout';
import '../../styles/Messages.css';

const Messages = () => {
  const [messages, setMessages] = useState([]);
  const [users, setUsers] = useState([]);
  const [departments] = useState([
    'Customer Service Department',
    'Medical Department',
    'Human Resources Department'
  ]);
  const [newMessage, setNewMessage] = useState({
    content: '',
    receiver: '',
    department: '',
    broadcast: false,
  });

  useEffect(() => {
    fetchMessages();
    fetchUsers();
  }, []);

  const fetchMessages = async () => {
    try {
      const res = await fetch('https://clinic123.onrender.com/api/messages', {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      const data = await res.json();
      if (res.ok) {
        setMessages(data);
      }
    } catch (err) {
      console.error('Error fetching messages:', err);
    }
  };

  const fetchUsers = async () => {
    try {
      const res = await fetch('https://clinic123.onrender.com/api/users/list', {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      const data = await res.json();
      if (res.ok && Array.isArray(data.users)) {
        setUsers(data.users);
      } else if (res.ok && Array.isArray(data)) {
        setUsers(data);
      }
    } catch (err) {
      console.error('Error fetching users:', err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const messageData = {
      content: newMessage.content,
      receiver: newMessage.receiver || null,
      department: newMessage.department || null,
      broadcast: newMessage.broadcast,
    };

    try {
      const res = await fetch('https://clinic123.onrender.com/api/messages', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(messageData),
      });

      if (res.ok) {
        setNewMessage({ content: '', receiver: '', department: '', broadcast: false });
        fetchMessages();
      }
    } catch (err) {
      console.error('Error sending message:', err);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'broadcast') {
      setNewMessage({
        content: '',
        broadcast: checked,
        receiver: '',
        department: '',
      });
    } else {
      setNewMessage((prev) => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
        ...(name === 'receiver' ? { department: '', broadcast: false } : {}),
        ...(name === 'department' ? { receiver: '', broadcast: false } : {}),
      }));
    }
  };

  const getRecipientLabel = (msg) => {
    if (msg.broadcast) return 'All Users (Broadcast)';
    if (msg.receiver) return `User: ${msg.receiver.email}`;
    if (msg.department) return `Department: ${msg.department}`;
    return 'Unknown';
  };

  return (
    <DashboardLayout pageTitle="Messages">
      <div className="messages-modern-layout">
        <div className="modern-inbox card">
          <h3>Inbox</h3>
          {messages.length === 0 ? (
            <p>No messages to display.</p>
          ) : (
            messages.map((msg) => (
              <div className="modern-message-card" key={msg._id}>
                <div className="modern-message-header">
                  <span className="modern-message-sender">{msg.sender?.email || 'Unknown Sender'}</span>
                  <span className="modern-message-date">{new Date(msg.timestamp).toLocaleString()}</span>
                </div>
                <div className="modern-message-body">{msg.content}</div>
                <div className="modern-message-footer">To: {getRecipientLabel(msg)}</div>
              </div>
            ))
          )}
        </div>
        <div className="modern-new-message card">
          <h3>Send New Message</h3>
          <form onSubmit={handleSubmit} className="modern-message-form">
            <div className="form-group form-checkbox">
              <label>
                <input
                  type="checkbox"
                  name="broadcast"
                  checked={newMessage.broadcast}
                  onChange={handleChange}
                />
                Broadcast to all users
              </label>
            </div>
            {!newMessage.broadcast && (
              <>
                <div className="form-group">
                  <label htmlFor="receiver">Select Specific User:</label>
                  <select
                    name="receiver"
                    value={newMessage.receiver}
                    onChange={handleChange}
                    disabled={newMessage.broadcast || newMessage.department}
                  >
                    <option value="">-- Choose user --</option>
                    {users.map((user) => (
                      <option key={user._id} value={user._id}>
                        {user.email}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="department">Or Send to Department:</label>
                  <select
                    name="department"
                    value={newMessage.department}
                    onChange={handleChange}
                    disabled={newMessage.broadcast || newMessage.receiver}
                  >
                    <option value="">-- Choose department --</option>
                    {departments.map((dept) => (
                      <option key={dept} value={dept}>
                        {dept}
                      </option>
                    ))}
                  </select>
                </div>
              </>
            )}
            <div className="form-group">
              <label htmlFor="content">Message:</label>
              <textarea
                name="content"
                rows="4"
                value={newMessage.content}
                onChange={handleChange}
                required
              />
            </div>
            <button type="submit" className="modern-send-button">Send</button>
          </form>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Messages;
